<template>
  <div style="margin-top:20px">
    <el-form
      ref="form"
      label-width="80px"
      :model="form"
    >
      <el-form-item
        label="标题"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.title"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item
        label="内容"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.content"
          type="textarea"
          :rows="3"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item
        label="类型"
        style="margin-right:15px"
      >
        <el-select
          v-model="form.type"
          :disabled="true"
        >
          <el-option
            v-for="(v,k) in dicts.bannerType"
            :key="k"
            :label="v"
            :value="k"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="链接"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.url"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item
        label="图片"
        style="margin-right:15px"
      >
        <ImgUpload
          :upload-config="{ lebal: '轮播图片', prefix: 'img', form, suffix: '', modal: false }"
          :parent-data="{ isDetail: true }"
          isicon
        />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import request from '@/utils/request'
import ImgUpload from "@/components/ImgUpload";

export default {
  name: 'BannerDetail',
  components: {
    ImgUpload
  },
  data() {
    return {
      emptyForm: {},
      dicts: { bannerType: {}},
      form: {
        code: '',
        branchCode: '',
        title: '',
        content: '',
        img: '',
        type: '',
        url: '',
        status: ''
      }
    }
  },
  created() {
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form))
  },
  methods: {
    // 获取页面信息
    getInfo(code, dicts) {
      this.dicts = dicts
      // 查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      request({ url: `/ntocc-basic-api/banner/${code}`, method: 'get' }).then(response => {
        this.form = response.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin-top: 50px;
  }
</style>
